/* istanbul ignore file */
import { type Dispatch } from "@reduxjs/toolkit";
import domainsDataService from "../../Library/SimulatedPhishing/Domains/services/domainsDataService";
import { type WithPagedDataV2 } from "../../../interfaces/getPagedDataRequest";
import {
  type Domain,
  type DomainStatus,
  type DomainTypes,
  type DomainApiResponse,
} from "../../Library/SimulatedPhishing/Domains/types/state";
import { fetchBegin, fetchSuccess } from "./domainManagementSlice";

export type FetchDomainsParams = WithPagedDataV2<{}>;

export const fetchDomains = (params: FetchDomainsParams) => async (dispatch: Dispatch) => {
  dispatch(fetchBegin());
  try {
    const result = await domainsDataService.getDomainsAsync(params);

    const mappedDomains: Domain[] = result.items.map((item: DomainApiResponse) => ({
      id: item.id,
      name: item.domain ?? item.name,
      dateAdded: item.dateAdded ? item.dateAdded.split("T")[0] : "",
      status: (item.statusId ?? item.status) as DomainStatus,
      type: (item.domainTypeId ?? item.domainType) as DomainTypes,
      usedBy:
        item.usedByAccounts?.map((acc) => ({
          id: acc.id,
          name: acc.name,
        })) || [],
    }));

    dispatch(fetchSuccess({ items: mappedDomains, totalCount: result.totalCount }));
  } catch {
    dispatch(fetchSuccess({ items: [], totalCount: 0 }));
  }
};
